import { z } from 'zod'
import type { CatalogLayer } from '#/domain/catalog/CatalogLayer'
import type { CatalogPage } from '#/domain/catalog/CatalogRepository'

export const CatalogLayerDtoSchema = z
  .object({
    Id: z.string(),
    Title: z.string().optional(),
    Description: z.string().optional(),
    Icon: z.string().optional(),
    Active: z.boolean(),
    Available: z.boolean(),
    Private: z.boolean(),
    Url: z.string().optional(),
    LayerTypeName: z.string().optional(),
    Applications: z.array(z.string()),
    AssignedCategories: z
      .array(z.object({ Id: z.string(), DisplayName: z.string().optional() }))
      .default([]),
  })
  .transform((raw): CatalogLayer => ({
    Id: raw.Id,
    Title: raw.Title,
    Description: raw.Description,
    Icon: raw.Icon,
    Active: raw.Active,
    Available: raw.Available,
    Private: raw.Private,
    Url: raw.Url,
    LayerTypeName: raw.LayerTypeName,
    Applications: raw.Applications,
    AssignedCategories: raw.AssignedCategories.map((c) => ({
      Id: c.Id,
      DisplayName: c.DisplayName ?? c.Id,
    })),
  }))

export type CatalogLayerResponseDto = z.input<typeof CatalogLayerDtoSchema>

export function toDomain(raw: CatalogLayerResponseDto): CatalogLayer {
  return CatalogLayerDtoSchema.parse(raw)
}

export function toDomainList(raw: CatalogLayerResponseDto[]): CatalogLayer[] {
  return raw.map(toDomain)
}

const CatalogLayerPageDtoSchema = z
  .object({
    Items: z.array(CatalogLayerDtoSchema),
    Total: z.number(),
  })
  .transform((raw): CatalogPage<CatalogLayer> => ({
    items: raw.Items,
    total: raw.Total,
  }))

export type CatalogLayerPageResponseDto = z.input<typeof CatalogLayerPageDtoSchema>

export function toDomainPage(raw: CatalogLayerPageResponseDto): CatalogPage<CatalogLayer> {
  return CatalogLayerPageDtoSchema.parse(raw)
}
